(function () {
  const installKey = "__flexibleDepositsGlobalCartControllerInstalled";
  if (window[installKey]) return;
  window[installKey] = true;

  const config = window.__flexibleDepositsGlobalCartControllerConfig || {};
  const checkoutUrl = config.checkoutUrl || "/apps/deposits/checkout";
  const checkoutButtonLabel =
    config.checkoutButtonLabel || "Checkout with deposit";
  const loadingLabel = config.loadingLabel || "Starting checkout...";
  const originalFetch = window.fetch ? window.fetch.bind(window) : null;
  const handledEvents = typeof WeakSet !== "undefined" ? new WeakSet() : null;
  let cartHasDepositLines = false;
  let nativeCheckoutInProgress = false;
  let bypassNextCheckout = false;
  let refreshTimer = null;
  let mutationTimer = null;

  function markEventHandled(event) {
    if (!event) return;
    if (handledEvents) {
      handledEvents.add(event);
      return;
    }

    try {
      event.__flexibleDepositsGlobalHandled = true;
    } catch (_error) {}
  }

  function eventWasHandled(event) {
    if (!event) return false;
    if (handledEvents) return handledEvents.has(event);
    return Boolean(event.__flexibleDepositsGlobalHandled);
  }

  function normalizeCartLineProperties(properties) {
    const normalized = {};
    if (!properties || typeof properties !== "object") return normalized;

    Object.keys(properties).forEach((key) => {
      const value = properties[key];
      if (typeof value === "string") {
        normalized[key] = value;
      }
    });

    return normalized;
  }

  function cartContainsDepositLine(cart) {
    return Boolean(
      cart &&
        Array.isArray(cart.items) &&
        cart.items.some(
          (item) =>
            item &&
            item.properties &&
            String(item.properties._deposit_enabled || "").toLowerCase() ===
              "true"
        )
    );
  }

  function getElementClassName(element) {
    if (!element || typeof element.className !== "string") return "";
    return element.className;
  }

  function getAncestorContext(element) {
    const parts = [];
    let current = element;
    let depth = 0;

    while (current && depth < 6) {
      parts.push(current.id || "");
      parts.push(getElementClassName(current));
      parts.push(
        current.getAttribute ? current.getAttribute("data-cart") || "" : ""
      );
      current = current.parentElement;
      depth += 1;
    }

    return parts.join(" ").toLowerCase();
  }

  function isIgnoredDepositControl(candidate) {
    return Boolean(
      candidate &&
        (candidate.hasAttribute("data-native-product-checkout") ||
          candidate.hasAttribute("data-native-cart-add") ||
          candidate.hasAttribute("data-native-deposit-cart-checkout") ||
          candidate.closest("[data-native-deposit-cart-checkout-root]") ||
          candidate.closest(".deposit-selector"))
    );
  }

  function getControlLabel(candidate) {
    if (!candidate) return "";
    return [
      candidate.textContent || "",
      candidate.value || "",
      candidate.getAttribute("aria-label") || "",
      candidate.getAttribute("name") || "",
      candidate.getAttribute("id") || "",
      getElementClassName(candidate),
    ].join(" ");
  }

  function isLikelyCheckoutControl(candidate) {
    if (!candidate || isIgnoredDepositControl(candidate)) return false;

    const label = getControlLabel(candidate);
    const href = candidate.getAttribute("href") || "";
    const name = (candidate.getAttribute("name") || "").toLowerCase();
    const formId = candidate.getAttribute("form") || "";
    const closestForm = candidate.closest("form");
    const formAction = closestForm
      ? closestForm.getAttribute("action") || ""
      : "";
    const ancestorContext = getAncestorContext(candidate);
    const isNamedCheckout =
      name === "checkout" ||
      candidate.id === "CartDrawer-Checkout" ||
      candidate.classList.contains("cartCheckout");
    const isCheckoutLink = /\/checkout(?:[?#/]|$)/i.test(href);
    const isCartForm =
      formId === "cart" ||
      /\/cart(?:[?#/]|$)/i.test(formAction) ||
      Boolean(closestForm && closestForm.id === "cart");
    const isCartContext =
      ancestorContext.indexOf("cart") !== -1 ||
      ancestorContext.indexOf("drawer") !== -1;

    return Boolean(
      isNamedCheckout ||
        isCheckoutLink ||
        (candidate.classList.contains("checkout") &&
          (isCartForm || isCartContext)) ||
        (/checkout/i.test(label) && (isCartForm || isCartContext))
    );
  }

  function findCheckoutControl(target) {
    if (!target) return null;
    const start = target.nodeType === 1 ? target : target.parentElement;
    if (!start || typeof start.closest !== "function") return null;

    const candidate = start.closest(
      'button, input[type="submit"], input[type="button"], a'
    );
    if (!candidate || !isLikelyCheckoutControl(candidate)) return null;
    return candidate;
  }

  function findCheckoutForm(target, submitter) {
    if (!target) return null;
    const form =
      target.matches && target.matches("form")
        ? target
        : target.closest && target.closest("form");
    if (!form) return null;

    const action = form.getAttribute("action") || "";
    const isCartForm =
      form.id === "cart" ||
      /\/cart(?:[?#/]|$)/i.test(action) ||
      getAncestorContext(form).indexOf("cart") !== -1;
    const submitterIsCheckout = Boolean(
      submitter && findCheckoutControl(submitter)
    );
    const formHasCheckout = Boolean(
      form.querySelector(
        '[name="checkout"], #CartDrawer-Checkout, .cartCheckout, .checkout, a[href*="/checkout"]'
      )
    );

    return isCartForm && (submitterIsCheckout || formHasCheckout) ? form : null;
  }

  function uniqueControls(controls) {
    const unique = [];
    controls.forEach((control) => {
      if (control && unique.indexOf(control) === -1) {
        unique.push(control);
      }
    });
    return unique;
  }

  function getCheckoutControls() {
    const candidates = Array.from(
      document.querySelectorAll(
        'button, input[type="submit"], input[type="button"], a[href], [data-fd-global-deposit-checkout]'
      )
    );

    return uniqueControls(
      candidates.filter(
        (candidate) =>
          candidate.getAttribute("data-fd-global-deposit-checkout") ===
            "true" || findCheckoutControl(candidate) === candidate
      )
    );
  }

  function usesValueLabel(control) {
    return control && control.tagName === "INPUT" && "value" in control;
  }

  function canReplaceTextLabel(control) {
    return Boolean(
      control && !usesValueLabel(control) && control.children.length === 0
    );
  }

  function applyDepositCheckoutLabel(control) {
    if (!control) return;

    if (control.getAttribute("data-fd-global-deposit-checkout") !== "true") {
      control.setAttribute(
        "data-fd-global-original-text",
        usesValueLabel(control)
          ? control.value || ""
          : control.textContent || ""
      );
      control.setAttribute(
        "data-fd-global-original-aria-label",
        control.getAttribute("aria-label") || ""
      );
    }

    control.setAttribute("data-fd-global-deposit-checkout", "true");
    control.setAttribute("aria-label", checkoutButtonLabel);

    if (usesValueLabel(control)) {
      if (control.value !== checkoutButtonLabel) {
        control.value = checkoutButtonLabel;
      }
      return;
    }

    if (
      canReplaceTextLabel(control) &&
      control.textContent !== checkoutButtonLabel
    ) {
      control.textContent = checkoutButtonLabel;
    }
  }

  function restoreCheckoutLabel(control) {
    if (
      !control ||
      control.getAttribute("data-fd-global-deposit-checkout") !== "true"
    )
      return;

    const originalText =
      control.getAttribute("data-fd-global-original-text") || "";
    const originalAriaLabel =
      control.getAttribute("data-fd-global-original-aria-label") || "";

    if (usesValueLabel(control)) {
      control.value = originalText;
    } else if (canReplaceTextLabel(control)) {
      control.textContent = originalText;
    }

    if (originalAriaLabel) {
      control.setAttribute("aria-label", originalAriaLabel);
    } else {
      control.removeAttribute("aria-label");
    }

    control.removeAttribute("data-fd-global-deposit-checkout");
    control.removeAttribute("data-fd-global-original-text");
    control.removeAttribute("data-fd-global-original-aria-label");
  }

  function updateCheckoutButtons() {
    if (!document.body) return;
    document.body.classList.toggle(
      "fd-global-native-cart-deposit-active",
      cartHasDepositLines
    );

    getCheckoutControls().forEach((control) => {
      if (cartHasDepositLines) {
        applyDepositCheckoutLabel(control);
      } else {
        restoreCheckoutLabel(control);
      }
    });
  }

  function setCheckoutLoading(isLoading, triggerButton) {
    if (!triggerButton) return;

    if (isLoading) {
      if (!triggerButton.hasAttribute("data-fd-global-loading-text")) {
        triggerButton.setAttribute(
          "data-fd-global-loading-text",
          usesValueLabel(triggerButton)
            ? triggerButton.value || ""
            : triggerButton.textContent || ""
        );
      }
      triggerButton.setAttribute("aria-busy", "true");
      if ("disabled" in triggerButton) {
        triggerButton.disabled = true;
      }
      if (usesValueLabel(triggerButton)) {
        triggerButton.value = loadingLabel;
      } else if (canReplaceTextLabel(triggerButton)) {
        triggerButton.textContent = loadingLabel;
      }
      return;
    }

    const originalText = triggerButton.getAttribute(
      "data-fd-global-loading-text"
    );
    if (originalText !== null) {
      if (usesValueLabel(triggerButton)) {
        triggerButton.value = originalText;
      } else if (canReplaceTextLabel(triggerButton)) {
        triggerButton.textContent = originalText;
      }
    }

    triggerButton.removeAttribute("aria-busy");
    triggerButton.removeAttribute("data-fd-global-loading-text");
    if ("disabled" in triggerButton) {
      triggerButton.disabled = false;
    }
  }

  function showCheckoutError(error) {
    const message =
      error && error.message
        ? error.message
        : "Could not start deposit checkout.";
    console.error("[Flexible Deposits]", message);
    window.alert(message);
  }

  function updateCartState(cart) {
    cartHasDepositLines = cartContainsDepositLine(cart);
    updateCheckoutButtons();
  }

  async function fetchCart() {
    if (!originalFetch) {
      throw new Error("Your browser does not support deposit checkout.");
    }

    const response = await originalFetch("/cart.js", {
      headers: { Accept: "application/json" },
    });
    const cart = await response.json();
    updateCartState(cart);
    return cart;
  }

  function submitCartFormForCheckout(form, triggerButton) {
    if (!form || typeof HTMLFormElement === "undefined") return false;

    const submit =
      HTMLFormElement.prototype && HTMLFormElement.prototype.submit;
    if (typeof submit !== "function") return false;

    const shouldValidate =
      !form.noValidate &&
      !(triggerButton && triggerButton.hasAttribute("formnovalidate"));
    if (shouldValidate) {
      if (typeof form.reportValidity === "function") {
        if (!form.reportValidity()) return true;
      } else if (
        typeof form.checkValidity === "function" &&
        !form.checkValidity()
      ) {
        return true;
      }
    }

    const submitterName = triggerButton
      ? triggerButton.getAttribute("name") || ""
      : "";
    const submitterValue = triggerButton
      ? triggerButton.getAttribute("value") || ""
      : "";
    let submitterInput = null;
    const restoreFormAttributes = [];

    function applySubmitterOverride(submitterAttribute, formAttribute) {
      if (!triggerButton || !triggerButton.hasAttribute(submitterAttribute))
        return;

      restoreFormAttributes.push({
        name: formAttribute,
        value: form.getAttribute(formAttribute),
      });
      form.setAttribute(
        formAttribute,
        triggerButton.getAttribute(submitterAttribute) || ""
      );
    }

    if (submitterName) {
      submitterInput = document.createElement("input");
      submitterInput.type = "hidden";
      submitterInput.name = submitterName;
      submitterInput.value = submitterValue;
      form.appendChild(submitterInput);
    }

    applySubmitterOverride("formaction", "action");
    applySubmitterOverride("formmethod", "method");
    applySubmitterOverride("formenctype", "enctype");
    applySubmitterOverride("formtarget", "target");

    try {
      submit.call(form);
      return true;
    } catch (_error) {
      return false;
    } finally {
      if (submitterInput && submitterInput.parentNode) {
        submitterInput.parentNode.removeChild(submitterInput);
      }
      restoreFormAttributes.forEach((entry) => {
        if (entry.value === null) {
          form.removeAttribute(entry.name);
        } else {
          form.setAttribute(entry.name, entry.value);
        }
      });
    }
  }

  function shouldSubmitCartForm(triggerButton) {
    if (!triggerButton || !triggerButton.tagName) return false;

    const tagName = triggerButton.tagName.toUpperCase();
    const type = (triggerButton.getAttribute("type") || "").toLowerCase();
    const hasSubmitterOverride =
      triggerButton.hasAttribute("formaction") ||
      triggerButton.hasAttribute("formmethod") ||
      triggerButton.hasAttribute("formenctype") ||
      triggerButton.hasAttribute("formtarget");

    if (hasSubmitterOverride) return true;
    if (tagName === "BUTTON") return type === "" || type === "submit";
    if (tagName === "INPUT") return type === "submit" || type === "image";
    return false;
  }

  function continueStandardCheckout(triggerButton) {
    bypassNextCheckout = true;
    window.setTimeout(() => {
      bypassNextCheckout = false;
    }, 0);

    if (triggerButton) {
      const href = triggerButton.getAttribute("href");
      if (href && /\/checkout(?:[?#/]|$)/i.test(href)) {
        window.location.href = href;
        return;
      }

      const form = triggerButton.form || triggerButton.closest("form");
      if (
        shouldSubmitCartForm(triggerButton) &&
        submitCartFormForCheckout(form, triggerButton)
      ) {
        return;
      }

      if (typeof triggerButton.click === "function") {
        const previousHref = window.location.href;
        triggerButton.click();
        if (window.location.href === previousHref) {
          window.location.href = "/checkout";
        }
        return;
      }
    }

    window.location.href = "/checkout";
  }

  async function startNativeCartCheckout(triggerButton) {
    if (nativeCheckoutInProgress) return;
    nativeCheckoutInProgress = true;
    setCheckoutLoading(true, triggerButton);

    try {
      const cart = await fetchCart();

      if (
        !cart ||
        !cart.token ||
        !Array.isArray(cart.items) ||
        cart.items.length === 0
      ) {
        throw new Error("Your cart is empty.");
      }

      if (!cartContainsDepositLine(cart)) {
        nativeCheckoutInProgress = false;
        setCheckoutLoading(false, triggerButton);
        continueStandardCheckout(triggerButton);
        return;
      }

      const response = await originalFetch(checkoutUrl, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          cart_token: cart.token,
          terms_accepted: true,
          items: cart.items.map((item) => ({
            key: item.key,
            product_id: item.product_id,
            variant_id: item.variant_id,
            quantity: item.quantity,
            properties: normalizeCartLineProperties(item.properties),
          })),
        }),
      });
      const result = await response.json().catch(() => ({}));

      if (!response.ok || !result.invoiceUrl) {
        throw new Error(result.error || "Could not start deposit checkout.");
      }

      window.location.href = result.invoiceUrl;
    } catch (error) {
      nativeCheckoutInProgress = false;
      setCheckoutLoading(false, triggerButton);
      showCheckoutError(error);
    }
  }

  function interceptCheckout(event, triggerButton) {
    if (bypassNextCheckout || eventWasHandled(event)) return;
    markEventHandled(event);
    event.preventDefault();
    event.stopImmediatePropagation();
    startNativeCartCheckout(triggerButton);
  }

  window.addEventListener(
    "click",
    function (event) {
      if (event.button && event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
        return;

      const checkoutButton = findCheckoutControl(event.target);
      if (!checkoutButton) return;

      interceptCheckout(event, checkoutButton);
    },
    true
  );

  window.addEventListener(
    "submit",
    function (event) {
      const form = findCheckoutForm(event.target, event.submitter);
      if (!form) return;

      const submitter =
        findCheckoutControl(event.submitter) ||
        form.querySelector(
          '[name="checkout"], #CartDrawer-Checkout, .cartCheckout, .checkout'
        );
      interceptCheckout(event, submitter);
    },
    true
  );

  function scheduleCartRefresh() {
    if (refreshTimer) return;
    refreshTimer = window.setTimeout(() => {
      refreshTimer = null;
      fetchCart().catch(() => updateCheckoutButtons());
    }, 80);
  }

  function isCartMutationRequest(input) {
    if (!input) return false;
    const requestUrl = typeof input === "string" ? input : input.url || "";
    if (!requestUrl) return false;

    try {
      const url = new URL(requestUrl, window.location.origin);
      return /^\/cart\/(?:add|change|update|clear)(?:\.js)?$/i.test(
        url.pathname
      );
    } catch (_error) {
      return false;
    }
  }

  if (originalFetch && !window.__flexibleDepositsGlobalFetchPatched) {
    window.__flexibleDepositsGlobalFetchPatched = true;
    window.fetch = function (input, init) {
      const responsePromise = originalFetch(input, init);
      if (isCartMutationRequest(input)) {
        responsePromise
          .then((response) => {
            if (response && response.ok) {
              scheduleCartRefresh();
            }
          })
          .catch(() => {});
      }
      return responsePromise;
    };
  }

  if (window.XMLHttpRequest && !window.__flexibleDepositsGlobalXhrPatched) {
    window.__flexibleDepositsGlobalXhrPatched = true;
    const originalOpen = window.XMLHttpRequest.prototype.open;
    const originalSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function (_method, url) {
      this.__flexibleDepositsCartMutation = isCartMutationRequest(url);
      return originalOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function () {
      if (this.__flexibleDepositsCartMutation) {
        this.addEventListener("loadend", function () {
          if (this.status >= 200 && this.status < 400) {
            scheduleCartRefresh();
          }
        });
      }
      return originalSend.apply(this, arguments);
    };
  }

  [
    "cart:updated",
    "cart:refresh",
    "cart:change",
    "cart-drawer:open",
    "theme:cart:change",
    "product:added",
  ].forEach((eventName) => {
    window.addEventListener(eventName, scheduleCartRefresh);
    document.addEventListener(eventName, scheduleCartRefresh);
  });

  if ("MutationObserver" in window && document.body) {
    const observer = new MutationObserver(() => {
      if (mutationTimer) return;
      mutationTimer = window.setTimeout(() => {
        mutationTimer = null;
        updateCheckoutButtons();
      }, 50);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  fetchCart().catch(() => updateCheckoutButtons());
})();
